<script lang="ts" setup>
  import type { Entry } from 'contentful'
  import type { TypePageSkeleton } from '~/types/contentful'

  const { data: pageDate, error: pageError } = await useFetch<
    Entry<TypePageSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
  >('/api/cms/page/gift-cards/purchase')

  if (!pageDate.value || pageError.value) {
    throw createError({
      statusCode: 404,
      statusMessage: 'No Gift Cards Data. Page not found',
      fatal: true
    })
  }

  useGrilldServerSeoMeta(pageDate.value?.fields.seo)
  useGrilldSeoHead({
    pageTitle: pageDate.value?.fields.seo?.fields.metaTitle ?? undefined,
    canonicalUrl: pageDate.value?.fields.seo?.fields.canonicalUrl ?? undefined,
    jsonLinkingData: pageDate.value?.fields.seo?.fields.jsonLinkingData ?? undefined
  })

  const giftCardStore = useGiftCardsStore()
  const { data, error } = await useFetch('/api/gift-cards/skins')

  if (!data.value || error.value) {
    throw createError({
      statusCode: 404,
      statusMessage: error.value?.message ?? 'Gift card skins not found',
      fatal: true
    })
  }

  giftCardStore.data.skinGroups = data.value.groups
</script>

<template>
  <div class="page-container module-paddings-h">
    <client-only>
      <CGiftCardStepper />
    </client-only>
  </div>
</template>

<style lang="scss" scoped>
  .page-container {
    background-color: var(--color-base-white);
    padding-top: 24px;
    padding-bottom: 64px;

    @include screenMdAndUp {
      padding-top: 48px;
    }
  }
</style>
